module.exports = __webpack_public_path__ + "static/media/teamBannertwo.31c2858d.png";